import type { AppRouteRecordRaw } from '@/router/types'

export const dataCenterRoutes: AppRouteRecordRaw[] = [
  {
    path: 'dataCenter',
    name: 'DataCenter',
    meta: { title: 'BI报表管理' },
    children: [
      {
        path: 'customerAnalysis',
        name: 'CustomerAnalysis',
        component: () => import('@/views/dataCenter/reportCenter/customerAnalysis/index.vue'),
        meta: { title: '客户分析', keepAlive: true }
      },
      {
        path: 'jobAnalysis',
        name: 'JobAnalysis',
        meta: { title: '工作分析' },
        children: [
          {
            path: 'callStatistics',
            name: 'CallStatistics',
            component: () => import('@/views/dataCenter/reportCenter/jobAnalysis/index.vue'),
            meta: { title: '通话统计' }
          },
          {
            path: 'employeeDetail',
            name: 'EmployeeDetail',
            component: () =>
              import('@/views/dataCenter/reportCenter/orderMakingDetail/employee/index.vue'),
            meta: { title: '员工做单明细表' }
          },
          {
            path: 'departmentDetail',
            name: 'DepartmentDetail',
            component: () =>
              import('@/views/dataCenter/reportCenter/orderMakingDetail/department/index.vue'),
            meta: { title: '部门做单明细表' }
          }
        ]
      },
      {
        path: 'earningReport',
        name: 'EarningReport',
        component: () => import('@/views/dataCenter/reportCenter/earningReport/index.vue'),
        meta: { title: '业绩报表' },
        children: [
          {
            path: 'employeePerformance',
            name: 'EmployeePerformance',
            component: () =>
              import('@/views/dataCenter/reportCenter/earningReport/employeePerformance/index.vue'),
            meta: { title: '员工业绩' }
          },
          {
            path: 'departmentPerformance',
            name: 'DepartmentPerformance',
            component: () =>
              import(
                '@/views/dataCenter/reportCenter/earningReport/departmentPerformance/index.vue'
              ),
            meta: { title: '部门业绩' }
          },
          {
            path: 'trendAnalysis',
            name: 'TrendAnalysis',
            component: () =>
              import('@/views/dataCenter/reportCenter/earningReport/trendAnalysis/index.vue'),
            meta: { title: '趋势分析' }
          }
        ]
      },
      {
        path: 'systemRank',
        name: 'SystemRank',
        component: () => import('@/views/dataCenter/reportCenter/systemRank/index.vue'),
        meta: { title: '体系排名' },
        children: [
          {
            path: 'revenueList',
            name: 'RevenueList',
            component: () =>
              import('@/views/dataCenter/reportCenter/systemRank/revenueList/index.vue'),
            meta: { title: '创收榜单' }
          }
        ]
      },

      {
        path: 'newCustomerAnalysis',
        name: 'NewCustomerAnalysis',
        meta: { title: '新客分析' },
        children: [
          {
            path: 'firstCallAging',
            name: 'FirstCallAging',
            component: () => import('@/views/cps/newCustomerAnalysis/firstCallAging/index.vue'),
            meta: { title: '新客户首呼时效', keepAlive: true }
          }
        ]
      },
      {
        path: 'funnelConversion',
        name: 'FunnelConversion',
        meta: { title: '漏斗转化' },
        children: [
          {
            path: 'callData',
            name: 'CallData',
            component: () => import('@/views/cps/funnelConversion/callData/index.vue'),
            meta: { title: '通话数据', keepAlive: true }
          }
        ]
      }
    ]
  }
]
